import { Country } from '@afterpay/types'

import { Theme } from '../Theme'
import { LogoNames, ThemedLogoNames } from '.'
import { LOGO_NAMES, THEMED_LOGO_NAMES } from './logos/constants'

type NonKelpieTheme = Exclude<Theme, Theme.Kelpie | Theme.KelpieMint>
type ThemedLogoComponentName = Record<NonKelpieTheme, LogoNames | ThemedLogoNames>

export const mapBronteToThemedLogo: Record<LogoNames | ThemedLogoNames, ThemedLogoComponentName> = {
  [LOGO_NAMES.AFTERPAY]: {
    [Theme.AP]: LOGO_NAMES.AFTERPAY,
    [Theme.Cash]: THEMED_LOGO_NAMES.CASHAPP_AFTERPAY,
    [Theme.Pegasus]: THEMED_LOGO_NAMES.CASHAPP_AFTERPAY,
  },
  [LOGO_NAMES.CLEARPAY]: {
    [Theme.AP]: LOGO_NAMES.CLEARPAY,
    [Theme.Cash]: LOGO_NAMES.CLEARPAY,
    [Theme.Pegasus]: LOGO_NAMES.CLEARPAY,
  },
  [THEMED_LOGO_NAMES.ARCADE_AFTERPAY_PILL]: {
    [Theme.AP]: THEMED_LOGO_NAMES.ARCADE_AFTERPAY_PILL,
    [Theme.Cash]: THEMED_LOGO_NAMES.ARCADE_AFTERPAY_PILL,
    [Theme.Pegasus]: THEMED_LOGO_NAMES.ARCADE_AFTERPAY_PILL,
  },
  [THEMED_LOGO_NAMES.ARCADE_CLEARPAY_PILL]: {
    [Theme.AP]: LOGO_NAMES.CLEARPAY,
    [Theme.Cash]: LOGO_NAMES.CLEARPAY,
    [Theme.Pegasus]: LOGO_NAMES.CLEARPAY,
  },
  [THEMED_LOGO_NAMES.CASHAPP_AFTERPAY]: {
    [Theme.AP]: THEMED_LOGO_NAMES.CASHAPP_AFTERPAY,
    [Theme.Cash]: THEMED_LOGO_NAMES.CASHAPP_AFTERPAY,
    [Theme.Pegasus]: THEMED_LOGO_NAMES.CASHAPP_AFTERPAY,
  },
  [THEMED_LOGO_NAMES.ARCADE_AFTERPAY]: {
    [Theme.AP]: THEMED_LOGO_NAMES.ARCADE_AFTERPAY,
    [Theme.Cash]: THEMED_LOGO_NAMES.ARCADE_AFTERPAY,
    [Theme.Pegasus]: THEMED_LOGO_NAMES.ARCADE_AFTERPAY,
  },
}

const isKelpieTheme = (theme: Theme): theme is Theme.Kelpie | Theme.KelpieMint => theme === Theme.Kelpie || theme === Theme.KelpieMint

export const getLogoByThemeAndCountry = (logoName: LogoNames | ThemedLogoNames, theme: Theme, country?: Country): LogoNames | ThemedLogoNames => {
  if (isKelpieTheme(theme)) {
    return logoName === LOGO_NAMES.CLEARPAY ? THEMED_LOGO_NAMES.ARCADE_CLEARPAY_PILL : THEMED_LOGO_NAMES.ARCADE_AFTERPAY_PILL
  }

  const isArcadeTheme = theme === Theme.Cash || theme === Theme.Pegasus

  if (isArcadeTheme && country) {
    const arcadeAfterpayLogos: Partial<Record<Country, LogoNames | ThemedLogoNames>> = {
      [Country.US]: THEMED_LOGO_NAMES.CASHAPP_AFTERPAY,
    }

    if (logoName === LOGO_NAMES.AFTERPAY) {
      return arcadeAfterpayLogos[country] ?? LOGO_NAMES.AFTERPAY
    }
    if (logoName === LOGO_NAMES.CLEARPAY) {
      return LOGO_NAMES.CLEARPAY
    }
  }

  return mapBronteToThemedLogo[logoName]?.[theme] || logoName
}

export const mapThemedLogoViewBox: Record<LogoNames | ThemedLogoNames, string> = {
  [LOGO_NAMES.AFTERPAY]: '0 0 108 20',
  [LOGO_NAMES.CLEARPAY]: '0 0 108 20',
  [THEMED_LOGO_NAMES.ARCADE_AFTERPAY_PILL]: '0 0 95 32',
  [THEMED_LOGO_NAMES.ARCADE_CLEARPAY_PILL]: '0 0 95 32',
  [THEMED_LOGO_NAMES.CASHAPP_AFTERPAY]: '0 0 98 24',
  [THEMED_LOGO_NAMES.ARCADE_AFTERPAY]: '0 0 98 24',
}
